// Instant cart math: as soon as a quantity changes in the cart drawer or cart page, each line's
// price shows unit price × quantity and the estimated total sums every line, before the server
// refresh arrives (which then replaces these numbers with the exact ones, including discounts).
// Markup: [data-cart-line="<cart id>"] wraps a line; [data-line-total][data-unit-cents] is its
// price; input[data-quantity-display] is its quantity; [data-cart-total-for="<cart id>"] is the
// total, with data-money-sample = 1234567.89 rendered through the Liquid money filter.
if (!window.__vantaraCartLiveTotal) {
  window.__vantaraCartLiveTotal = true;

  const SAMPLE_DIGITS = '123456789';

  function moneyParts(sample) {
    const match = sample.match(/\d[\d.,'\s\u00a0]*\d/);
    if (!match) return null;
    const numeric = match[0];
    const hasDecimals = /[.,]\d{2}$/.test(numeric) && numeric.replace(/\D/g, '') === SAMPLE_DIGITS;
    const decimal = hasDecimals ? numeric.charAt(numeric.length - 3) : '';
    const body = hasDecimals ? numeric.slice(0, -3) : numeric;
    const thousands = (body.match(/[^\d]/) || [''])[0];
    return { prefix: sample.slice(0, match.index), suffix: sample.slice(match.index + numeric.length), decimal, thousands };
  }

  function format(cents, parts) {
    const whole = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, parts.thousands);
    const number = parts.decimal ? `${whole}${parts.decimal}${String(cents % 100).padStart(2, '0')}` : whole;
    return `${parts.prefix}${number}${parts.suffix}`;
  }

  function recalc(cartId) {
    const totalEl = document.querySelector(`[data-cart-total-for="${CSS.escape(cartId)}"]`);
    const parts = totalEl?.dataset.moneySample ? moneyParts(totalEl.dataset.moneySample) : null;
    if (!parts) return;

    let sum = 0;
    document.querySelectorAll(`[data-cart-line="${CSS.escape(cartId)}"]`).forEach((line) => {
      const unit = Number(line.querySelector('[data-line-total]')?.dataset.unitCents) || 0;
      const quantity = Math.max(0, parseInt(line.querySelector('input[data-quantity-display]')?.value, 10) || 0);
      const cents = unit * quantity;
      sum += cents;
      line.querySelectorAll('[data-line-total]').forEach((el) => { el.textContent = format(cents, parts); });
    });

    const target = totalEl.querySelector('bdi') || totalEl;
    target.textContent = format(sum, parts);
  }

  // s-cart updates the quantity input synchronously in its own command/change handlers;
  // read it on the next tick so the new value is in place.
  const schedule = (cartId) => { if (cartId) setTimeout(() => recalc(cartId), 0); };

  document.addEventListener('command', (event) => {
    if (event.command !== '--update-quantity') return;
    const line = event.source?.closest?.('[data-cart-line]');
    schedule(line?.dataset.cartLine);
  }, true);

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('input[data-quantity-display]')) return;
    schedule(event.target.closest('[data-cart-line]')?.dataset.cartLine);
  });
}
